export default "__VITE_ASSET__a7216503__"